module.exports = __webpack_public_path__ + "img/ER.82c4b443.png";